import { action } from 'easy-peasy';
import { IActionShowSidebarMenu } from '~/store/app/types';

const hideSnackbar: IActionShowSidebarMenu = action(state => {
  state.sidebarMenuOpened = true;
});

export default hideSnackbar;
